import { render, staticRenderFns } from "./PostsSingle.vue?vue&type=template&id=502a3626&"
import script from "./PostsSingle.vue?vue&type=script&lang=js&"
export * from "./PostsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports